import { take, fork, race, call, cancel } from 'redux-saga/effects';

export function* takeFirstCancelable(triggerAction, cancelAction, continueAction, saga) {
    while (true) {
        const action = yield take(triggerAction);
        const task = yield fork(saga, action);

        yield race([
            take(continueAction),
            call(function* () {
                yield take(cancelAction);
                yield cancel(task);
            }),
        ]);
    }
}
